"use strict";

angular.module("core")
.constant("TAGS_INPUT_VALIDATION_REGEX", /^[_\-a-zA-Z0-9\u00C0-\u017F]+$/);



//////////////////
// WEBPACK FOOTER
// ./core/tags-input/tags-input.constant.js
// module id = 382
// module chunks = 0